import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BrewDay, BrewDayAlertButton } from '@/components/batches/brew-day';
import { useReturn } from '@/lib/return-ticket';

export const Route = createFileRoute('/batches/$batchId/brew')({
  component: BrewDayPage,
});

function BrewDayPage() {
  const { batchId } = Route.useParams();
  const navigate = useNavigate();
  // Brew day is reached from the recipe list, the recipe editor and the batch
  // page, so "the way out" is genuinely different each time: it returns to
  // whichever entry started it (PLAN-LIST-STATE D-LS7), and only a brew day
  // opened cold — a bookmark, or a reload on the brew stand — pushes the batch
  // page the way it always did.
  const exit = useReturn(() => {
    void navigate({ to: '/batches/$batchId', params: { batchId } });
  });
  return (
    <div className="flex min-h-full flex-col">
      {/* The notification opt-in lives here, outside the checklist, so the
          permission prompt is unmistakably attached to a deliberate tap. */}
      <div className="flex justify-end px-4 pt-2 sm:px-6">
        <BrewDayAlertButton />
      </div>
      {/* Keyed for the reason the batch page is (see `index.tsx`): a brew day
          reused across a param change would keep the timers, steps and ticks of
          the brew before it. Each brew day is a new mount. */}
      <BrewDay key={batchId} batchId={batchId} onExit={exit} />
    </div>
  );
}
